import React from "react";
import styles from "./ThemeToggleButton.module.css";
import { SunIcon } from "../../ui-library/_icons/SunIcon.tsx";
import { MoonIcon } from "../../ui-library/_icons/MoonIcon.tsx";

export type Theme = "light" | "dark";

export interface ThemeToggleButtonProps {
  currentTheme: Theme;
  onThemeChange: (theme: Theme) => void;
  className?: string;
  disabled?: boolean;
  label?: string;
}

export const ThemeToggleButton: React.FC<ThemeToggleButtonProps> = ({
  currentTheme,
  onThemeChange,
  className = "",
  disabled = false,
  label,
}) => {
  const handleToggle = () => {
    if (!disabled) {
      const newTheme = currentTheme === "light" ? "dark" : "light";
      onThemeChange(newTheme);
    }
  };

  const ariaLabel =
    label || `Switch to ${currentTheme === "light" ? "dark" : "light"} mode`;

  return (
    <button
      className={`${styles.ThemeToggleButton} ${className}`}
      onClick={handleToggle}
      disabled={disabled}
      aria-label={ariaLabel}
      title={ariaLabel}
    >
      {currentTheme === "light" ? <MoonIcon /> : <SunIcon />}
    </button>
  );
};
